import { useState, useEffect, React } from "react";
import { Link, Grid, Column, Button, OrderedList, ToggletipLabel, ToggletipContent, ToggletipButton, ToggletipActions, Toggletip, ListItem, TextInput, Stack, InlineNotification, Theme } from '@carbon/react';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import './login.scss';
import Cookies from "universal-cookie";


const cookies = new Cookies();

if (sessionStorage.getItem('usuario')) {
  window.location.href = "/#/recibos";
}


const Login = () => {

  const ColorHrLine = ({ color }) => (<hr style={{ color: color, backgroundColor: color, height: 2 }} />);
  let headers = new Headers(); headers.append('Content-Type', 'application/json');
  let spanHeight = ({ height }) => (<span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: height }} />);
  
  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState([]);

  const cerrar = () => {
    setError({ "error": 0 });
  }

  function MsgLogin() {
   
    let botonLogin = document.getElementById("MsgLogin");
    setError({ "error": "" });
    botonLogin.disabled = false;
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if ([usuario, password].includes('')) {
      setError({ "error": 1, "Mensaje": "Los campos están vacíos" })
      setTimeout(MsgLogin, 5000);
      let botonLogin = document.getElementById("MsgLogin");
      botonLogin.disabled = true;
      return;
    }

    const datos = {};
    datos.Correo = usuario;
    datos.Password = password;

    fetch(process.env.REACT_APP_URL_SERVICE_GEB_LOGIN, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(datos)
    }).then((res) => res.json()).then((data) => {
      if(data.estatus == 0){
        cookies.set("usuarioId", data.SDTLogin.Id);
        cookies.set("rfc", data.SDTLogin.RFC);
        sessionStorage.setItem("rfc", data.SDTLogin.RFC);
        sessionStorage.setItem("nombre", data.SDTLogin.NOMBRE);
        sessionStorage.setItem("perfilId", data.SDTLogin.PerfilId);
        sessionStorage.setItem("usuarioId", data.SDTLogin.Id);

        let modulos = data.SDTLogin.Permisos;
        if(modulos != undefined){
          const modRecibosNomina = modulos.filter((item) => {
            return item.PerfilModuloModuloId == Number(1);
          });
          cookies.set('modRecibosNomina', modRecibosNomina);

          const modOtrosRecibos = modulos.filter((item) => {
            return item.PerfilModuloModuloId == Number(2);
          });
          cookies.set('modOtrosRecibos', modOtrosRecibos);

          const modUsuarioEmpleados = modulos.filter((item) => {
            return item.PerfilModuloModuloId == Number(3);
          });
          cookies.set('modUsuarioEmpleados', modUsuarioEmpleados);

          const modPerfiles = modulos.filter((item) => {
            return item.PerfilModuloModuloId == Number(4);
          });
          cookies.set('modPerfiles', modPerfiles);

          const modPermisos = modulos.filter((item) => {
            return item.PerfilModuloModuloId == Number(5);
          });
          cookies.set('modPermisos', modPermisos);

          const modCargaMasiva = modulos.filter((item) => {
            return item.PerfilModuloModuloId == Number(6);
          });
          cookies.set('modCargaMasiva', modCargaMasiva);
        }
        
        window.location.href = "/#/recibos";
      }
      else {
        setError({ "error": 1, "Mensaje": data.Mensaje })
      }
    });

    setError({ "error": 0 })
  }

  useEffect(() => {

   
  }, []);


  const registro = () => {
    window.location.href = "/#/validaRfc";
  }

  return <>

    <Theme theme="g100">
      <Grid className="login-container">
        <Column lg={7} md={6} sm={2}>

          <h1>Iniciar sesión<span></span></h1>
          <Link onClick={registro} target="blank">Registro.</Link>
          <br/> <br/>
          <form onSubmit={handleSubmit} style={{ maxWidth: '400px' }} >
            <Stack gap={5}>
             
              <TextInput type="text" value={usuario} onChange={(e) => setUsuario(e.target.value)} labelText="Usuario" />
              
              <div className="container">
                  <div className="recPassword"><Link href="/#/recuperarPassword">¿Olvidaste tu contraseña?</Link></div>
              </div>
              <TextInput type="password" value={password} onChange={(e) => setPassword(e.target.value)} labelText="Contraseña" />
              <Button type="submit" id="MsgLogin">Ingresar</Button>
              
            </Stack>
            <br/>
            <ColorHrLine color="gray"/>
          </form>
          
          
         {/* <ToggletipLabel className="help">¿Necesitas ayuda?</ToggletipLabel> */}
          <Toggletip align="right" autoAlign={true}>
          
            <ToggletipButton className="help" label="Show information">
                ¿Necesitas ayuda?
            </ToggletipButton>
            <ToggletipContent>
              <Grid>
                <Column lg={16} md={8} sm={4} >
                  <ListItem>
                    Correo: 
                    <OrderedList nested>
                      <ListItem>
                        soporte.geb@humansite.com.mx
                      </ListItem>
                    </OrderedList>
                  </ListItem>
                  <ListItem>
                    Tel: 
                    <OrderedList nested>
                      <ListItem>
                        55 7011 1101
                      </ListItem>
                      <ListItem>
                        56 1383 8747
                      </ListItem>
                    </OrderedList>
                  </ListItem>
                  <ListItem>
                    Horario de atención:
                    <OrderedList nested>
                      <ListItem>
                        Lunes a Viernes de 9:00 am. a 6:00 pm.
                      </ListItem>
                    </OrderedList>
                  </ListItem>
                </Column>
              </Grid>
            </ToggletipContent>
          </Toggletip>
          <br/><br/>
          {error.error == 1 && 
            <InlineNotification style={{maxWidth: '420px'}} title={error.Mensaje} 
                                lowContrast={true} 
                                onClick={cerrar} />
          }
        </Column>
      </Grid>
    </Theme>
  </>
};

export default Login;